import React, { useEffect, useMemo, useState } from "react";

const actionLabels = {
  nginx_test: "nginx 설정 검사",
  nginx_reload: "nginx reload",
  nginx_restart: "nginx restart",
  nginx_start: "nginx start",
  backend_restart: "백엔드 재시작",
  certbot_dry_run: "인증서 갱신 테스트",
  docker_ps: "Docker 상태 확인",
};

const managedServers = [
  {
    key: "106", name: "106 운영 본체", host: "106.250.181.106", port: 22, username: "root", role: "TOBE AI/TIA",
    summary: "TOBE AI 관리자/사용자 앱, TIA Admin, Face/OCR, 게시판, CCTV, TTS, Callcenter PoC, Docker 기반 보조 서비스 운영",
    paths: ["/home/tobe-project", "/home/tobe-board", "/home/tobe-agent-v1", "/home/tobe-v2", "/opt/tobe-ai-gateway"],
    services: ["nginx", "tobe-ai-backend", "tia-admin", "tobe-board", "tobe-cctv-gateway", "facerec-api", "faceverify-api", "ocr-api", "tobe-tts-worker", "callcenter-poc", "docker"],
    ports: ["80", "443", "3478", "8001", "8002", "8080", "8088", "8095", "8098", "8099", "8100", "8200", "8300", "8400", "8888", "11434"],
    dbs: [
      { name: "TOBE AI MariaDB", engine: "MariaDB", host: "106.250.181.107", port: 3306, database: "tobe_ai", user: "tobe_ai", note: "106 backend가 107 DB에 접속" },
      { name: "Docker PostgreSQL/pgvector", engine: "PostgreSQL", host: "docker:tobe-db", port: 5432, database: "(컨테이너 내부)", user: "(비공개)", note: "tobe-db 컨테이너, 화면에는 비밀값 미노출" },
    ],
  },
  {
    key: "107", name: "107 DB·AI", host: "106.250.181.107", port: 22, username: "root", role: "DB/AI/Pass",
    summary: "MariaDB, PostgreSQL 16, Ollama, TOBE AI Gateway, 통역톡, Boarding API, Face/OCR, eobok SFL 운영",
    paths: ["/opt/tobe-ai-gateway", "/opt/tobe-interpreter", "/home/eobok-sfl", "/home/eobok-app", "/home/eobok-pg-staging"],
    services: ["httpd", "mariadb", "postgresql-16", "ollama", "tobe-ai-gateway", "tobe-interpreter", "tobe-pass-boarding", "tobe-pass-face", "tobe-pass-ocr", "eobok-app", "eobok-sfl-backend"],
    ports: ["22", "80", "443", "3306", "8000", "8001", "8010", "8100", "8200", "11434"],
    dbs: [
      { name: "TOBE AI MariaDB", engine: "MariaDB", host: "127.0.0.1", port: 3306, database: "tobe_ai", user: "tobe_ai", note: "주 운영 DB" },
      { name: "PostgreSQL 16", engine: "PostgreSQL", host: "127.0.0.1", port: 5432, database: "(서버에서 확인)", user: "postgres", note: "서비스 active, DB 목록 별도 확인 필요" },
    ],
  },
  {
    key: "122", name: "122 웹·메일", host: "112.217.102.122", port: 2222, username: "root", role: "Legacy/Web/Mail",
    summary: "CentOS 7 기반 Apache/Tomcat/MariaDB/Postfix/PM2 레거시 웹·메일 서버",
    paths: ["/home/hyosun", "/home/love/www", "/home/tour/www", "/opt/tomcat/latest"],
    services: ["httpd", "tomcat", "mariadb", "postfix", "pm2-root"],
    ports: ["22", "2222", "80", "8080", "3306"],
    dbs: [{ name: "Legacy MariaDB", engine: "MariaDB", host: "127.0.0.1", port: 3306, database: "(서버에서 확인)", user: "root", note: "로컬 DB 로그인 가능, DB명/소유 서비스 매핑 추가 확인 필요" }],
  },
  {
    key: "124", name: "124 라우터·SMS", host: "112.217.102.124", port: 2222, username: "root", role: "AI Router/SMS",
    summary: "Apache/PHP-FPM/Tomcat/MariaDB/PM2 기반 SMS, AI Router, LiveTour, SKB DB Agent 서버",
    paths: ["/home/sms/www/server", "/home/livetour/app", "/home/nsh/www", "/home/int/API", "/home/api/www", "/opt/dbagent"],
    services: ["httpd", "php-fpm", "tomcat", "mariadb", "pm2-root", "dbagent", "livetour-app", "named", "tailscaled"],
    ports: ["21", "22", "53", "2222", "80", "443", "3001", "5000", "8005", "8009", "8080", "8085", "8790", "9000", "3306"],
    dbs: [{ name: "Router/SMS MariaDB", engine: "MariaDB", host: "127.0.0.1", port: 3306, database: "(SMS/LiveTour 확인)", user: "root", note: "DB 서비스 active, 로컬 DB 로그인은 추가 자격 확인 필요" }],
  },
  {
    key: "125", name: "125 패스·승선", host: "112.217.102.125", port: 2222, username: "root", role: "eobok3/승선",
    summary: "eobok3 Spring/Admin, 승선 키오스크, Face-match shim, SMS, Ollama, MariaDB, Apache/PHP-FPM 운영",
    paths: ["/home/eobok3/www", "/home/eobok3/spring-backend", "/home/eobok3/new-spring", "/home/eobok3/passenger-kiosk", "/home/eobok35", "/home/sms/workspace", "/opt/fk-facematch"],
    services: ["httpd", "php-fpm", "mariadb", "docker", "ollama", "eobok3-spring", "eobok3-newspring", "passenger-kiosk", "passenger-central", "fk-facematch-shim", "sms", "tailscaled"],
    ports: ["21", "22", "2222", "80", "443", "3001", "5000", "8080", "8088", "8090", "8091", "8770", "8781", "8788", "3306", "11434"],
    dbs: [{ name: "eobok3/pass MariaDB", engine: "MariaDB", host: "127.0.0.1", port: 3306, database: "(eobok3/spass 확인)", user: "root", note: "로컬 DB 로그인 가능, 서비스별 DB명 매핑 추가 확인 필요" }],
  },
];

const readCommands = {
  specs: {
    label: "서버 사양",
    command: "echo '## HOST'; hostname; uptime; echo '## OS'; cat /etc/os-release 2>/dev/null | head -8; uname -r; echo '## CPU'; lscpu 2>/dev/null | egrep 'Model name|CPU\\\\(s\\\\)|Core|Socket' || true; echo '## MEMORY'; free -h; echo '## DISK'; df -hT | head -40",
  },
  packages: {
    label: "패키지",
    command: "echo '## PACKAGES'; (rpm -qa 2>/dev/null || dpkg-query -W 2>/dev/null || true) | grep -Ei 'nginx|httpd|mariadb|mysql|docker|ollama|node|npm|python|java|jdk|tomcat|postfix|redis|certbot|php|uvicorn|fastapi' | sort | head -220",
  },
  db: {
    label: "DB 상태",
    command: "DBCLI=$(command -v mariadb || command -v mysql || true); if [ -z \"$DBCLI\" ]; then echo 'mysql/mariadb client 없음'; exit 0; fi; echo '## VERSION'; $DBCLI -NBe \"SELECT VERSION(), @@hostname, @@port\" 2>/dev/null || echo 'DB 로그인 실패: root socket 또는 DB 계정 확인 필요'; echo '## DATABASES'; $DBCLI -NBe \"SHOW DATABASES\" 2>/dev/null | grep -Ev '^(information_schema|performance_schema|mysql|sys)$' || true; echo '## SIZE MB'; $DBCLI -NBe \"SELECT table_schema, ROUND(SUM(data_length+index_length)/1024/1024,1) FROM information_schema.tables GROUP BY table_schema ORDER BY 2 DESC LIMIT 20\" 2>/dev/null || true",
  },
  services: {
    label: "운영 서비스",
    command: "echo '## RUNNING SERVICES'; systemctl list-units --type=service --state=running --no-pager --no-legend | grep -Ei 'tobe|tia|ollama|nginx|httpd|mysql|mariadb|docker|agent|board|uvicorn|spring|kiosk|face|ocr|pass|gateway|tomcat|postfix|dbagent|livetour|sms|passenger|eobok' || true; echo '## PORTS'; ss -ltnp 2>/dev/null | grep -E ':(22|2222|80|443|8000|8010|8080|8090|8098|8099|8100|8200|8400|11434|3306) ' || true",
  },
  logs: {
    label: "최근 오류",
    command: "journalctl -p err -n 80 --no-pager 2>/dev/null || dmesg --level=err,warn 2>/dev/null | tail -80",
  },
};

function ServiceCard({ title, service }) {
  const ok = service?.ok;
  return (
    <div className={`server-status-card ${ok ? "ok" : "failed"}`}>
      <span>{title}</span>
      <strong>{service?.active || "unknown"}</strong>
      <small>enabled: {service?.enabled || "-"}</small>
    </div>
  );
}

function EnvironmentCard({ environment }) {
  if (!environment) return null;
  const missing = environment.missing || [];
  return (
    <div className={`server-status-card ${environment.ok ? "ok" : "failed"}`}>
      <span>필수 환경변수</span>
      <strong>{environment.ok ? "정상" : "확인 필요"}</strong>
      <small>{environment.ok ? "DB_PASSWORD, JWT_SECRET_KEY 설정됨" : `${missing.map((item) => item.key).join(", ")} 누락`}</small>
    </div>
  );
}

function CheckBlock({ title, result }) {
  if (!result) return null;
  return (
    <details className={`server-check-block ${result.ok ? "ok" : "failed"}`}>
      <summary>
        <strong>{title}</strong>
        <span>{result.ok ? "정상" : "확인 필요"}</span>
      </summary>
      <pre className="patch-preview validation-log">{result.output || "출력 없음"}</pre>
    </details>
  );
}

function copyText(text) {
  navigator.clipboard?.writeText(text).catch(() => {});
}

function ServerManagementPanel({ apiBase, token, serverStatus, onRefresh, onAction, onFetchOpsServers, onSaveOpsServer, onOpsHealth, onOpsExec, onFetchOpsServiceMap, onOpsInventory, onFetchOpsHealthHistory }) {
  const [busyAction, setBusyAction] = useState("");
  const [result, setResult] = useState(null);
  const [pendingAction, setPendingAction] = useState("");
  const [tab, setTab] = useState("overview");
  const [selectedKey, setSelectedKey] = useState("106");
  const [savedTargets, setSavedTargets] = useState([]);
  const [opsBusy, setOpsBusy] = useState("");
  const [opsResult, setOpsResult] = useState(null);
  const [lastOpsByServer, setLastOpsByServer] = useState({});
  const [opsAudit, setOpsAudit] = useState([]);
  const [serviceMap, setServiceMap] = useState(null);
  const [inventoryByServer, setInventoryByServer] = useState({});
  const [healthHistory, setHealthHistory] = useState([]);
  const [tiaHealth, setTiaHealth] = useState(null);
  const [selfProject, setSelfProject] = useState(null);
  const [codexOps, setCodexOps] = useState(null);
  const [workflowSmoke, setWorkflowSmoke] = useState(null);
  const [dependencyStatus, setDependencyStatus] = useState(null);
  const [finalStatus, setFinalStatus] = useState(null);
  const [incompleteStatus, setIncompleteStatus] = useState(null);
  const [externalInputVerifications, setExternalInputVerifications] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [form, setForm] = useState({ name: "", host: "", port: 22, username: "root", auth_type: "key", private_key: "", password: "", group_name: "운영" });

  const selected = managedServers.find((item) => item.key === selectedKey) || managedServers[0];
  const savedTarget = useMemo(() => savedTargets.find((item) => String(item.host) === selected.host && Number(item.port || 22) === Number(selected.port)), [savedTargets, selected]);
  const targetId = selected.key === "106" ? "local" : savedTarget?.id;
  const lastOps = lastOpsByServer[selected.key];
  const mappedServer = serviceMap?.servers?.[selected.key] || null;
  const inventory = inventoryByServer[selected.key] || null;
  const serverReadiness = useMemo(() => managedServers.map((server) => {
    const saved = server.key === "106" || savedTargets.some((item) => String(item.host) === server.host && Number(item.port || 22) === Number(server.port));
    const last = lastOpsByServer[server.key];
    const failed = last?.ok === false;
    const checked = Boolean(last);
    return {
      ...server,
      saved,
      checked,
      failed,
      state: failed ? "failed" : checked ? "checked" : saved ? "ready" : "needed",
      label: failed ? "확인 필요" : checked ? "점검 완료" : saved ? "관리 가능" : "SSH 저장 필요",
    };
  }), [savedTargets, lastOpsByServer]);
  const selectedReadiness = serverReadiness.find((item) => item.key === selected.key) || serverReadiness[0];
  const selectedAudit = useMemo(() => {
    const ids = new Set([String(targetId || ""), selected.host, selected.name].filter(Boolean));
    return (opsAudit || []).filter((item) => ids.has(String(item.target_id || "")) || String(item.target_name || "").includes(selected.name)).slice(0, 6);
  }, [opsAudit, selected, targetId]);
  const nextAction = !targetId
    ? "SSH 접속정보를 저장한 뒤 헬스체크를 실행하세요."
    : lastOps?.ok === false
      ? "최근 점검이 실패했습니다. 접속정보, 방화벽, 포트, 서비스명을 다시 확인하세요."
      : lastOps
        ? "필요한 탭에서 DB, 패키지, 서비스 로그를 이어서 확인하세요."
        : "헬스체크로 접속 상태를 먼저 확인하세요.";
  const sshCommand = `ssh${Number(selected.port) === 22 ? "" : ` -p ${selected.port}`} ${selected.username}@${selected.host}`;
  const checks = serverStatus?.checks || {};
  const disk = serverStatus?.disk || {};
  const certificateInventory = checks?.certificate_inventory || {};

  const loadOpsTargets = async () => {
    if (!onFetchOpsServers) return;
    try {
      const data = await onFetchOpsServers();
      setSavedTargets(data.servers || []);
    } catch (err) {
      setOpsResult({ ok: false, output: err.message });
    }
  };

  const loadTiaHealth = async () => {
    if (!apiBase) return;
    try {
      const response = await fetch(`${apiBase}/api/tia/ingest/health`);
      const data = await response.json().catch(() => ({}));
      setTiaHealth(response.ok ? data : { ok: false, error: data.detail || "TIA 상태를 불러오지 못했습니다." });
    } catch (err) {
      setTiaHealth({ ok: false, error: err.message });
    }
  };

  const loadOpsAudit = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/workspace/ops/audit?limit=60`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setOpsAudit(response.ok ? (data.logs || []) : []);
    } catch (err) {
      setOpsAudit([]);
    }
  };

  const loadServiceMap = async () => {
    if (!onFetchOpsServiceMap) return;
    try {
      const data = await onFetchOpsServiceMap();
      setServiceMap(data);
    } catch (err) {
      setServiceMap({ status: "failed", error: err.message, servers: {} });
    }
  };

  const loadHealthHistory = async (serverKey = selected.key) => {
    if (!onFetchOpsHealthHistory || !serverKey) return;
    try {
      const data = await onFetchOpsHealthHistory(serverKey);
      setHealthHistory(data.history || []);
    } catch (err) {
      setHealthHistory([]);
    }
  };

  const loadSelfProject = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/codex/self-project/status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setSelfProject(response.ok ? data.self_project : { ok: false, code: data.detail || "status_failed" });
    } catch (err) {
      setSelfProject({ ok: false, code: err.message });
    }
  };

  const loadCodexOps = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/codex/ops-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setCodexOps(response.ok ? data : { status: "failed", error: data.detail || "Codex 운영 상태를 불러오지 못했습니다." });
    } catch (err) {
      setCodexOps({ status: "failed", error: err.message });
    }
  };

  const loadWorkflowSmoke = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/workspace/smoke-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setWorkflowSmoke(response.ok ? data : { status: "failed", error: data.detail || "업무 기능 상태를 불러오지 못했습니다." });
    } catch (err) {
      setWorkflowSmoke({ status: "failed", error: err.message });
    }
  };

  const loadDependencyStatus = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/dependencies/status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setDependencyStatus(response.ok ? data : { status: "failed", error: data.detail || "의존성 상태를 불러오지 못했습니다." });
    } catch (err) {
      setDependencyStatus({ status: "failed", error: err.message });
    }
  };

  const loadFinalStatus = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/operations/final-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setFinalStatus(response.ok ? data : { status: "failed", error: data.detail || "최종 운영 상태를 불러오지 못했습니다." });
    } catch (err) {
      setFinalStatus({ status: "failed", error: err.message });
    }
  };

  const loadIncompleteStatus = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/operations/incomplete-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setIncompleteStatus(response.ok ? data : { status: "failed", error: data.detail || "미완성 인벤토리를 불러오지 못했습니다." });
    } catch (err) {
      setIncompleteStatus({ status: "failed", error: err.message });
    }
  };

  const loadExternalInputVerifications = async () => {
    if (!apiBase || !token) return;
    try {
      const response = await fetch(`${apiBase}/admin/operations/external-input-verifications`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json().catch(() => ({}));
      setExternalInputVerifications(response.ok ? data.summary : { status: "failed", error: data.detail || "외부 입력 검증 상태를 불러오지 못했습니다." });
    } catch (err) {
      setExternalInputVerifications({ status: "failed", error: err.message });
    }
  };

  useEffect(() => {
    loadOpsTargets();
    loadOpsAudit();
    loadServiceMap();
    loadHealthHistory(selectedKey);
    loadTiaHealth();
    loadSelfProject();
    loadCodexOps();
    loadWorkflowSmoke();
    loadDependencyStatus();
    loadFinalStatus();
    loadIncompleteStatus();
    loadExternalInputVerifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadHealthHistory(selectedKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKey]);

  const updateExternalInputVerification = async (item, status) => {
    if (!apiBase || !token || !item?.key) return;
    let evidence = "";
    if (status === "verified") {
      evidence = window.prompt(`${item.label} 검증 근거를 입력하세요. 비밀번호/API key/토큰은 입력하지 마세요.`, item.verification_api || "");
      if (!evidence) return;
    } else if (!window.confirm(`${item.label} 항목을 다시 대기 상태로 바꾸시겠습니까?`)) {
      return;
    }
    setOpsBusy(`verify-${item.key}`);
    try {
      const response = await fetch(`${apiBase}/admin/operations/external-input-verifications/${item.key}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ status, evidence_note: evidence }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.detail || "검증 상태 저장 실패");
      setExternalInputVerifications(data.summary);
      await loadIncompleteStatus();
      await loadFinalStatus();
      setOpsResult({ ok: true, output: `${item.label} 검증 상태가 저장되었습니다.` });
    } catch (err) {
      setOpsResult({ ok: false, output: err.message });
    } finally {
      setOpsBusy("");
    }
  };

  const executeAction = async (action) => {
    setBusyAction(action);
    setResult(null);
    setPendingAction("");
    try {
      const data = await onAction(action);
      setResult(data);
      await onRefresh?.();
    } catch (err) {
      setResult({ status: "failed", ok: false, log: err.message });
    } finally {
      setBusyAction("");
    }
  };

  const runAction = async (action) => {
    const risky = ["nginx_reload", "nginx_restart", "nginx_start", "backend_restart", "certbot_dry_run"].includes(action);
    if (risky) {
      setPendingAction(action);
      return;
    }
    await executeAction(action);
  };

  const openForm = () => {
    setForm({ name: selected.name, host: selected.host, port: selected.port, username: selected.username, auth_type: "key", private_key: "", password: "", group_name: selected.role });
    setFormOpen(true);
  };

  const saveTarget = async () => {
    if (!form.host.trim()) return;
    setOpsBusy("save");
    try {
      await onSaveOpsServer?.(form);
      await loadOpsTargets();
      await loadOpsAudit();
      setFormOpen(false);
      setOpsResult({ ok: true, output: "SSH 접속정보를 저장했습니다." });
    } catch (err) {
      setOpsResult({ ok: false, output: err.message });
    } finally {
      setOpsBusy("");
    }
  };

  const runOps = async (kind, command) => {
    if (!targetId) {
      setOpsResult({ ok: false, output: "이 서버는 아직 SSH 접속정보가 저장되지 않았습니다. 먼저 접속정보를 저장하세요.", command });
      return;
    }
    setOpsBusy(kind);
    setOpsResult(null);
    try {
      const data = kind === "health" ? await onOpsHealth?.(targetId, selected.key) : await onOpsExec?.(targetId, command);
      setOpsResult({ ...data, command });
      setLastOpsByServer((prev) => ({
        ...prev,
        [selected.key]: {
          ok: data?.ok !== false,
          kind,
          command,
          output: data?.raw || data?.output || "",
          metrics: data?.metrics || [],
          checkedAt: new Date().toLocaleString(),
        },
      }));
      if (kind === "health") await loadHealthHistory(selected.key);
      await loadOpsTargets();
      await loadOpsAudit();
    } catch (err) {
      setOpsResult({ ok: false, output: err.message, command });
      setLastOpsByServer((prev) => ({
        ...prev,
        [selected.key]: {
          ok: false,
          kind,
          command,
          output: err.message,
          metrics: [],
          checkedAt: new Date().toLocaleString(),
        },
      }));
    } finally {
      setOpsBusy("");
    }
  };

  const runInventory = async () => {
    if (!targetId) {
      setOpsResult({ ok: false, output: "이 서버는 아직 SSH 접속정보가 저장되지 않았습니다. 먼저 접속정보를 저장하세요." });
      return;
    }
    setOpsBusy("inventory");
    try {
      const data = await onOpsInventory?.(targetId, selected.key);
      setInventoryByServer((prev) => ({ ...prev, [selected.key]: data }));
      setOpsResult({ ok: data?.ok !== false, output: "서버 인벤토리를 수집했습니다.", command: "inventory" });
      await loadOpsAudit();
    } catch (err) {
      setOpsResult({ ok: false, output: err.message, command: "inventory" });
    } finally {
      setOpsBusy("");
    }
  };

  const serviceCommand = (svc, mode) => {
    if (mode === "logs") return `journalctl -u ${svc} -n 120 --no-pager 2>/dev/null || echo 'journal 로그 없음 또는 서비스명 확인 필요'`;
    if (mode === "ports") return `ps -eo user,pid,lstart,cmd | grep -i '${svc}' | grep -v grep; echo '## PORTS'; ss -ltnp 2>/dev/null | grep -i '${svc}' || true`;
    return `systemctl status ${svc} --no-pager -l 2>/dev/null | head -90 || ps -ef | grep -i '${svc}' | grep -v grep || true`;
  };

  return (
    <section className="server-management-panel">
      <div className="deployment-history-header">
        <div>
          <p className="panel-kicker">SERVER CONTROL</p>
          <h3>서버 관리</h3>
          <span>서버별 SSH, DB, 운영 서비스 상태를 관리자 앱에서 분리 관리합니다.</span>
        </div>
        <button className="admin-approve-button" onClick={onRefresh}>새로고침</button>
      </div>

      <div className="server-url-grid">
        {["overview", "mapping", "inventory", "history", "ssh", "db", "services", "deps", "tia", "codex", "workflows", "final", "incomplete", "local"].map((item) => (
          <button key={item} type="button" className={tab === item ? "active" : ""} onClick={() => setTab(item)}>
            {item === "overview" ? "서버별 현황" : item === "mapping" ? "매핑" : item === "inventory" ? "인벤토리" : item === "history" ? "이력" : item === "ssh" ? "SSH" : item === "db" ? "DB" : item === "services" ? "서비스" : item === "deps" ? "AI/DB" : item === "tia" ? "TIA" : item === "codex" ? "Codex" : item === "workflows" ? "업무 기능" : item === "final" ? "최종 점검" : item === "incomplete" ? "미완성" : "106 로컬"}
          </button>
        ))}
      </div>

      <div className="ops-server-layout">
        <aside className="ops-server-list">
          {serverReadiness.map((server) => {
            return (
              <button key={server.key} type="button" className={`${selected.key === server.key ? "active" : ""} ${server.state}`} onClick={() => { setSelectedKey(server.key); setOpsResult(null); }}>
                <strong>{server.host}</strong>
                <span>{server.name} · {server.role}</span>
                <small>{server.label}</small>
              </button>
            );
          })}
        </aside>

        <div className="ops-server-detail">
          {tab === "overview" && (
            <>
              <div className="ops-server-hero">
                <div>
                  <p className="panel-kicker">{selected.role}</p>
                  <h3>{selected.name}</h3>
                  <span>{selected.summary}</span>
                </div>
                <div className="server-action-row">
                  <button className="admin-approve-button" onClick={openForm}>SSH 접속정보</button>
                  <button className="admin-approve-button" disabled={!!opsBusy} onClick={() => runOps("health")}>{opsBusy === "health" ? "점검 중..." : "헬스체크"}</button>
                  <button className="admin-approve-button" onClick={() => copyText(`${sshCommand}\n${readCommands.services.command}`)}>명령 복사</button>
                </div>
              </div>
              <div className="server-status-grid">
                <div className={`server-status-card ${targetId ? "ok" : "failed"}`}><span>SSH</span><strong>{targetId ? "ready" : "needed"}</strong><small>{selected.username}@{selected.host}:{selected.port}</small></div>
                <div className="server-status-card ok"><span>서비스</span><strong>{selected.services.length}</strong><small>{selected.services.slice(0, 3).join(", ")}</small></div>
                <div className="server-status-card ok"><span>포트</span><strong>{selected.ports.length}</strong><small>{selected.ports.map((p) => `:${p}`).join(" ")}</small></div>
                <div className={`server-status-card ${selectedReadiness?.failed ? "failed" : lastOps ? "ok" : "warning"}`}><span>최근 점검</span><strong>{lastOps ? (lastOps.ok ? "pass" : "fail") : "none"}</strong><small>{lastOps?.checkedAt || "아직 실행 전"}</small></div>
              </div>
              <div className={`ops-credential-guide ${targetId ? "ready" : "needed"}`}>
                <strong>다음 작업: {nextAction}</strong>
                <span>관리 범위: SSH, DB, 서비스, 패키지, 포트, 최근 오류 로그</span>
                <span>민감정보는 저장 후 화면에 다시 표시하지 않고, 명령 결과에도 비밀번호/API key를 입력하지 않는 방식으로 점검합니다.</span>
              </div>
              <div className="ops-db-grid">
                <article>
                  <strong>서버 사양 점검</strong>
                  <span>OS, 커널, CPU, 메모리, 디스크</span>
                  <small>탭: SSH · 명령: 서버 사양</small>
                </article>
                <article>
                  <strong>패키지/솔루션</strong>
                  <span>{selected.services.slice(0, 5).join(", ")}</span>
                  <small>탭: 서비스 · 명령: 전체 서비스 스캔</small>
                </article>
                <article>
                  <strong>DB 연결</strong>
                  <span>{selected.dbs.map((db) => `${db.engine} ${db.host}:${db.port}`).join(" · ")}</span>
                  <small>탭: DB · 비밀번호 노출 없이 서버 내부 클라이언트로 확인</small>
                </article>
                <article>
                  <strong>최근 결과</strong>
                  <span>{lastOps ? `${lastOps.kind} · ${lastOps.ok ? "정상" : "확인 필요"}` : "점검 이력 없음"}</span>
                  <small>{lastOps?.output ? lastOps.output.slice(0, 120) : "헬스체크를 실행하면 이곳에 요약이 남습니다."}</small>
                </article>
              </div>
              <details className="ops-feature-checklist">
                <summary>최근 서버 관리 이력</summary>
                <div>
                  {(selectedAudit.length ? selectedAudit : opsAudit.slice(0, 6)).map((item) => (
                    <code key={item.id || `${item.created_at}-${item.action}`}>
                      {(item.created_at || "").slice(0, 19)} · {item.action || "-"} · {item.ok === 1 ? "ok" : item.ok === 0 ? "failed" : "record"} · {item.target_name || item.target_id || "-"} · {(item.detail || "").slice(0, 120)}
                    </code>
                  ))}
                  {opsAudit.length === 0 && <span>아직 저장된 서버 관리 이력이 없습니다.</span>}
                </div>
              </details>
              <div className="ops-chip-section">
                <strong>주요 경로</strong>
                <div>{selected.paths.map((item) => <code key={item}>{item}</code>)}</div>
              </div>
            </>
          )}

          {tab === "mapping" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>도메인 · 앱 · API · DB 매핑</h3>
                  <span>{selected.host} 기준 운영 관계를 한 화면에서 확인합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={loadServiceMap}>매핑 새로고침</button>
              </div>
              {serviceMap?.error && <div className="admin-error compact">{serviceMap.error}</div>}
              <div className="server-status-grid">
                <div className="server-status-card ok"><span>도메인</span><strong>{mappedServer?.domains?.length ?? 0}</strong><small>{(mappedServer?.domains || []).slice(0, 2).join(", ") || "도메인 없음"}</small></div>
                <div className="server-status-card ok"><span>앱/솔루션</span><strong>{mappedServer?.apps?.length ?? selected.services.length}</strong><small>{(mappedServer?.apps || selected.services).slice(0, 2).join(", ")}</small></div>
                <div className="server-status-card ok"><span>API/포트</span><strong>{mappedServer?.apis?.length ?? selected.ports.length}</strong><small>{(mappedServer?.apis || selected.ports).slice(0, 3).join(" · ")}</small></div>
                <div className="server-status-card ok"><span>DB</span><strong>{mappedServer?.databases?.length ?? selected.dbs.length}</strong><small>{(mappedServer?.databases || selected.dbs.map((db) => db.name)).slice(0, 2).join(" · ")}</small></div>
              </div>
              <div className="ops-db-grid">
                {["domains", "apps", "apis", "databases", "upstream"].map((key) => (
                  <article key={key}>
                    <strong>{key === "domains" ? "도메인" : key === "apps" ? "앱/솔루션" : key === "apis" ? "API/포트" : key === "databases" ? "DB 연결" : "상호 의존"}</strong>
                    {(mappedServer?.[key] || []).map((item) => <em key={item}>{item}</em>)}
                    {!(mappedServer?.[key] || []).length && <span>등록된 항목 없음</span>}
                  </article>
                ))}
              </div>
              <pre className="patch-preview validation-log">{mappedServer ? JSON.stringify(mappedServer, null, 2) : "매핑 정보를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "inventory" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>실서버 인벤토리</h3>
                  <span>서버 사양, 패키지, 서비스, 포트, 도메인, 앱 파일, DB 목록, 인증서를 읽기 전용으로 수집합니다.</span>
                </div>
                <button className="admin-approve-button" disabled={!!opsBusy} onClick={runInventory}>{opsBusy === "inventory" ? "수집 중..." : "인벤토리 수집"}</button>
              </div>
              <div className={`ops-credential-guide ${targetId ? "ready" : "needed"}`}>
                <strong>{selected.name}: {targetId ? "수집 가능" : "SSH 접속정보 저장 필요"}</strong>
                <span>수집 명령은 설정/데이터를 변경하지 않고, 비밀번호/API key 원문을 조회하지 않습니다.</span>
              </div>
              {inventory?.inventory ? (
                <div className="ops-db-grid">
                  {Object.entries(inventory.inventory).map(([section, output]) => (
                    <article key={section}>
                      <strong>{section}</strong>
                      <pre className="patch-preview validation-log">{String(output || "출력 없음").slice(0, 2200)}</pre>
                    </article>
                  ))}
                </div>
              ) : (
                <pre className="patch-preview validation-log">아직 수집된 인벤토리가 없습니다. 이 서버의 접속정보를 저장한 뒤 인벤토리 수집을 실행하세요.</pre>
              )}
            </div>
          )}

          {tab === "history" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>헬스체크 이력</h3>
                  <span>{selected.host} 서버의 디스크, 메모리, 부하, 서비스 상태 점검 기록입니다.</span>
                </div>
                <button className="admin-approve-button" onClick={() => loadHealthHistory(selected.key)}>이력 새로고침</button>
              </div>
              <div className="ops-db-grid">
                {healthHistory.map((row) => (
                  <article key={row.id} className={row.overall === "bad" ? "failed" : row.overall === "warn" ? "warning" : ""}>
                    <strong>{row.created_at}</strong>
                    <span>{row.target_name || selected.name} · {row.overall || "unknown"} · {row.ok ? "ok" : "failed"}</span>
                    {(row.metrics || []).slice(0, 8).map((metric) => (
                      <em key={`${row.id}-${metric.key}`}>{metric.label}: {metric.value} · {metric.level}</em>
                    ))}
                  </article>
                ))}
                {healthHistory.length === 0 && <article><strong>이력 없음</strong><span>헬스체크를 실행하면 이곳에 시간순으로 저장됩니다.</span></article>}
              </div>
            </div>
          )}

          {tab === "ssh" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div><h3>SSH 관리</h3><span>{selected.host}:{selected.port} 접속정보 저장과 접속 점검</span></div>
                <button className="admin-approve-button" onClick={openForm}>저장/갱신</button>
              </div>
              <div className={`ops-credential-guide ${targetId ? "ready" : "needed"}`}>
                <strong>{selected.name} 접속 상태: {targetId ? "관리 가능" : "접속정보 저장 필요"}</strong>
                <span>호스트 {selected.host} · 포트 {selected.port} · 사용자 {selected.username}</span>
                <span>{targetId ? "헬스체크, DB 상태, 서비스 스캔을 실행할 수 있습니다." : "비밀번호 또는 SSH 키를 저장한 뒤 헬스체크 → 서비스 스캔 → DB 점검 순서로 확인하세요."}</span>
              </div>
              <div className="ops-check-steps">
                {["SSH 접속정보 저장", "접속 헬스체크", "서버 사양 확인", "운영 서비스 스캔", "DB 목록/용량 확인", "최근 오류 로그 확인"].map((step, index) => (
                  <span key={step}><b>{index + 1}</b>{step}</span>
                ))}
              </div>
              <pre className="patch-preview validation-log">{`${sshCommand}\n\n# 기본 점검\nhostname; uptime; df -h; free -h`}</pre>
              <div className="server-action-row">
                <button className="admin-approve-button" onClick={() => copyText(sshCommand)}>SSH 명령 복사</button>
                <button className="admin-approve-button" disabled={!!opsBusy} onClick={() => runOps("health")}>접속 헬스체크</button>
                <button className="admin-approve-button" disabled={!!opsBusy} onClick={() => runOps("specs", readCommands.specs.command)}>서버 사양</button>
                <button className="admin-approve-button" disabled={!!opsBusy} onClick={() => runOps("logs", readCommands.logs.command)}>최근 오류</button>
              </div>
            </div>
          )}

          {tab === "db" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div><h3>DB 관리</h3><span>DB 비밀번호를 화면에 저장하지 않고 SSH를 통해 읽기 전용 점검</span></div>
                <button className="admin-approve-button" disabled={!!opsBusy} onClick={() => runOps("db", readCommands.db.command)}>DB 상태 점검</button>
              </div>
              <div className="ops-db-grid">
                {selected.dbs.map((db) => (
                  <article key={`${db.name}-${db.host}`}>
                    <strong>{db.name}</strong>
                    <span>{db.engine} · {db.host}:{db.port}</span>
                    <small>DB {db.database} · USER {db.user}</small>
                    <em>{db.note}</em>
                  </article>
                ))}
              </div>
              <div className="server-action-row">
                <button className="admin-approve-button" onClick={() => runOps("db", readCommands.db.command)}>DB 목록/용량</button>
                <button className="admin-approve-button" onClick={() => runOps("db-backup", "find /home /opt /var/backups /backup /backups -maxdepth 4 -type f \\( -iname '*.sql' -o -iname '*.sql.gz' -o -iname '*dump*' -o -iname '*backup*' \\) -printf '%TY-%Tm-%Td %TH:%TM %s %p\\n' 2>/dev/null | sort | tail -80")}>백업 흔적</button>
                <button className="admin-approve-button" onClick={() => copyText(`${sshCommand}\n${readCommands.db.command}`)}>DB 점검 명령 복사</button>
              </div>
            </div>
          )}

          {tab === "services" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div><h3>서비스 관리</h3><span>운영 중인 솔루션, 서비스 상태, 로그, 포트를 서버별로 확인</span></div>
                <button className="admin-approve-button" disabled={!!opsBusy} onClick={() => runOps("services", readCommands.services.command)}>전체 서비스 스캔</button>
              </div>
              <div className="ops-service-list">
                {selected.services.map((svc) => (
                  <article key={svc}>
                    <strong>{svc}</strong>
                    <div>
                      <button className="admin-approve-button" onClick={() => runOps(`svc-${svc}`, serviceCommand(svc, "status"))}>상태</button>
                      <button className="admin-approve-button" onClick={() => runOps(`log-${svc}`, serviceCommand(svc, "logs"))}>로그</button>
                      <button className="admin-approve-button" onClick={() => runOps(`port-${svc}`, serviceCommand(svc, "ports"))}>포트</button>
                      <button className="admin-danger-button" onClick={() => copyText(`${sshCommand}\n# 서버에서 직접 확인 후 실행\nsystemctl restart ${svc}\nsystemctl status ${svc} --no-pager -l`)}>재시작 명령 복사</button>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          )}

          {tab === "deps" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>AI/DB 의존성</h3>
                  <span>106 백엔드가 의존하는 DB, Ollama, 외부 모델 키 설정 여부를 비밀값 없이 확인합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={loadDependencyStatus}>의존성 새로고침</button>
              </div>
              {dependencyStatus?.error && <div className="admin-error compact">{dependencyStatus.error}</div>}
              <div className="server-status-grid">
                <div className={`server-status-card ${dependencyStatus?.database?.tcp?.ok ? "ok" : "failed"}`}>
                  <span>MariaDB</span>
                  <strong>{dependencyStatus?.database?.tcp?.ok ? "online" : "check"}</strong>
                  <small>{dependencyStatus?.database?.host || "-"}:{dependencyStatus?.database?.port || "-"}</small>
                </div>
                <div className={`server-status-card ${dependencyStatus?.ollama?.local?.ok ? "ok" : "failed"}`}>
                  <span>106 Ollama</span>
                  <strong>{dependencyStatus?.ollama?.local?.models?.length ?? "-"}</strong>
                  <small>models · {dependencyStatus?.ollama?.local?.latency_ms ?? "-"}ms</small>
                </div>
                <div className={`server-status-card ${dependencyStatus?.ollama?.remote_107?.ok ? "ok" : "failed"}`}>
                  <span>107 Ollama</span>
                  <strong>{dependencyStatus?.ollama?.remote_107?.models?.length ?? "-"}</strong>
                  <small>models · {dependencyStatus?.ollama?.remote_107?.latency_ms ?? "-"}ms</small>
                </div>
              </div>
              <div className="ops-db-grid">
                <article>
                  <strong>설정 모델</strong>
                  {Object.entries(dependencyStatus?.configured_models || {}).map(([name, value]) => <em key={name}>{name}: {value || "-"}</em>)}
                </article>
                <article>
                  <strong>외부 공급자 키</strong>
                  {Object.entries(dependencyStatus?.external_providers || {}).map(([name, ready]) => <em key={name}>{name}: {ready ? "설정됨" : "미설정"}</em>)}
                </article>
                <article>
                  <strong>106 모델</strong>
                  {(dependencyStatus?.ollama?.local?.models || []).slice(0, 12).map((name) => <em key={name}>{name}</em>)}
                  {dependencyStatus?.ollama?.local?.error && <em className="ops-next-action">{dependencyStatus.ollama.local.error}</em>}
                </article>
                <article>
                  <strong>107 모델</strong>
                  {(dependencyStatus?.ollama?.remote_107?.models || []).slice(0, 12).map((name) => <em key={name}>{name}</em>)}
                  {dependencyStatus?.ollama?.remote_107?.error && <em className="ops-next-action">{dependencyStatus.ollama.remote_107.error}</em>}
                </article>
              </div>
              <pre className="patch-preview validation-log">{dependencyStatus ? JSON.stringify(dependencyStatus, null, 2) : "의존성 상태를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "tia" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>TIA 관찰/수집 상태</h3>
                  <span>106 운영 백엔드의 ingest, nonce, domain authz, OS observe 상태를 확인합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={loadTiaHealth}>TIA 새로고침</button>
              </div>
              <div className="server-status-grid">
                <div className={`server-status-card ${tiaHealth?.enabled ? "ok" : "failed"}`}>
                  <span>Ingest</span>
                  <strong>{tiaHealth?.enabled ? "active" : "off"}</strong>
                  <small>core: {tiaHealth?.core ? "ready" : "unavailable"}</small>
                </div>
                <div className={`server-status-card ${tiaHealth?.observe?.enabled && tiaHealth?.observe?.core ? "ok" : "failed"}`}>
                  <span>OS Observe</span>
                  <strong>{tiaHealth?.observe?.enabled ? "active" : "off"}</strong>
                  <small>rules: {tiaHealth?.observe?.rules ?? "-"}</small>
                </div>
                <div className={`server-status-card ${tiaHealth?.nonce_required ? "ok" : "failed"}`}>
                  <span>Replay Guard</span>
                  <strong>{tiaHealth?.nonce_required ? "nonce" : "off"}</strong>
                  <small>domain authz: {tiaHealth?.domain_authz ? "on" : "off"}</small>
                </div>
              </div>
              <div className="ops-chip-section">
                <strong>스코프 서비스</strong>
                <div>{(tiaHealth?.scoped_services || []).map((item) => <code key={item}>{item}</code>)}</div>
              </div>
              <div className="ops-chip-section">
                <strong>관찰 도메인</strong>
                <div>{(tiaHealth?.observe?.domains || []).map((item) => <code key={item}>{item}</code>)}</div>
              </div>
              {tiaHealth?.observe?.last_error && <div className="admin-error compact">{tiaHealth.observe.last_error}</div>}
              <pre className="patch-preview validation-log">{tiaHealth ? JSON.stringify(tiaHealth, null, 2) : "TIA 상태를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "codex" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>Codex self-project 상태</h3>
                  <span>자체 코딩 에이전트가 편집할 운영 루트 설정을 경로 노출 없이 확인합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={() => { loadSelfProject(); loadCodexOps(); }}>Codex 상태 새로고침</button>
              </div>
              <div className="server-status-grid">
                <div className={`server-status-card ${selfProject?.ok ? "ok" : "failed"}`}>
                  <span>Root Config</span>
                  <strong>{selfProject?.ok ? "ready" : "blocked"}</strong>
                  <small>{selfProject?.code || "explicit roots"}</small>
                </div>
                <div className={`server-status-card ${selfProject?.explicit_roots ? "ok" : "failed"}`}>
                  <span>Fallback</span>
                  <strong>{selfProject?.fallback_used ? "used" : "off"}</strong>
                  <small>하드코딩 fallback 차단</small>
                </div>
                <div className="server-status-card ok">
                  <span>Root Count</span>
                  <strong>{selfProject?.root_count ?? "-"}</strong>
                  <small>{selfProject?.project_id || "project id 확인 전"}</small>
                </div>
              </div>
              {selfProject?.canonical_roots_sha256 && (
                <div className="ops-chip-section">
                  <strong>canonical_roots_sha256</strong>
                  <div><code>{selfProject.canonical_roots_sha256}</code></div>
                </div>
              )}
              {codexOps?.summary && (
                <>
                  <div className="server-status-grid">
                    <div className={`server-status-card ${codexOps.summary.safe_defaults >= 3 ? "ok" : "warning"}`}>
                      <span>Write/Run Controls</span>
                      <strong>{codexOps.summary.safe_defaults}</strong>
                      <small>safe defaults / {codexOps.summary.controls}</small>
                    </div>
                    <div className={`server-status-card ${codexOps.summary.trace_ready ? "ok" : "failed"}`}>
                      <span>Trace</span>
                      <strong>{codexOps.runs?.count ?? 0}</strong>
                      <small>recent runs</small>
                    </div>
                    <div className={`server-status-card ${codexOps.summary.self_project_ready ? "ok" : "failed"}`}>
                      <span>Self Project</span>
                      <strong>{codexOps.summary.self_project_ready ? "ready" : "blocked"}</strong>
                      <small>{codexOps.self_project?.project_id || "-"}</small>
                    </div>
                  </div>
                  <div className="ops-db-grid">
                    {Object.entries(codexOps.controls || {}).map(([name, item]) => (
                      <article key={name} className={item.enabled ? "warning" : ""}>
                        <strong>{name}</strong>
                        <span>{item.enabled ? "활성" : "기본 차단"}</span>
                        <small>{item.env}</small>
                        <em>{item.policy}</em>
                      </article>
                    ))}
                    <article>
                      <strong>릴리즈 체크리스트</strong>
                      {(codexOps.release_checklist || []).map((item) => <em key={item}>{item}</em>)}
                    </article>
                    <article>
                      <strong>정책 문서</strong>
                      {(codexOps.policy_docs || []).map((item) => <em key={item.path}>{item.exists ? "있음" : "없음"} · {item.path}</em>)}
                    </article>
                  </div>
                </>
              )}
              {codexOps?.error && <div className="admin-error compact">{codexOps.error}</div>}
              <pre className="patch-preview validation-log">{selfProject ? JSON.stringify(selfProject, null, 2) : "Codex self-project 상태를 불러오는 중입니다."}</pre>
              <pre className="patch-preview validation-log">{codexOps ? JSON.stringify(codexOps, null, 2) : "Codex 운영 상태를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "workflows" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>업무 핵심 기능 스모크</h3>
                  <span>메일, 일정, 톡/회의, 근태의 테이블 준비와 실제 사용 흔적을 개인정보 없이 확인합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={loadWorkflowSmoke}>업무 기능 새로고침</button>
              </div>
              {workflowSmoke?.summary && (
                <div className="server-status-grid">
                  <div className="server-status-card ok"><span>기능 수</span><strong>{workflowSmoke.summary.features}</strong><small>메일/일정/톡/근태</small></div>
                  <div className="server-status-card ok"><span>운영 준비</span><strong>{workflowSmoke.summary.ready ?? workflowSmoke.summary.ok}</strong><small>계정/데이터 기준 통과</small></div>
                  <div className={`server-status-card ${workflowSmoke.summary.bad ? "failed" : "ok"}`}><span>주의</span><strong>{workflowSmoke.summary.warn + workflowSmoke.summary.bad}</strong><small>warn {workflowSmoke.summary.warn} · bad {workflowSmoke.summary.bad}</small></div>
                </div>
              )}
              {workflowSmoke?.error && <div className="admin-error compact">{workflowSmoke.error}</div>}
              <div className="ops-db-grid">
                {(workflowSmoke?.features || []).map((feature) => {
                  const countItems = Object.entries(feature).filter(([, value]) => value && typeof value === "object" && Number.isInteger(value.count));
                  return (
                    <article key={feature.key} className={feature.level === "bad" ? "failed" : feature.level === "warn" ? "warning" : ""}>
                      <strong>{feature.label}</strong>
                      <span>{feature.level === "good" ? "운영 준비됨" : feature.level === "warn" ? "조치 필요" : "테이블 확인 필요"}</span>
                      <small>테이블 {feature.tables?.existing?.length || 0}개 준비 · 누락 {feature.tables?.missing?.length || 0}개</small>
                      {countItems.map(([name, value]) => (
                        <em key={name}>{name}: {value.count}건{value.latest_at ? ` · 최근 ${value.latest_at}` : ""}</em>
                      ))}
                      {feature.next_action && <em className="ops-next-action">{feature.next_action}</em>}
                      {feature.tables?.missing?.length > 0 && <em>누락: {feature.tables.missing.join(", ")}</em>}
                      <details className="ops-feature-checklist">
                        <summary>API/점검 절차</summary>
                        <div>
                          {(feature.api_checks || []).map((check) => (
                            <code key={`${check.method}-${check.path}`}>{check.method} {check.path} · {check.purpose}</code>
                          ))}
                          {(feature.manual_checks || []).map((item) => (
                            <span key={item}>{item}</span>
                          ))}
                        </div>
                      </details>
                    </article>
                  );
                })}
              </div>
              <pre className="patch-preview validation-log">{workflowSmoke ? JSON.stringify(workflowSmoke, null, 2) : "업무 기능 상태를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "final" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>최종 운영 점검</h3>
                  <span>1~5차 개발 결과, 정책 문서, 106/107 의존성, 업무 기능 준비 상태를 한 번에 확인합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={loadFinalStatus}>최종 점검 새로고침</button>
              </div>
              {finalStatus?.summary && (
                <div className="server-status-grid">
                  <div className={`server-status-card ${finalStatus.summary.blocked ? "warning" : "ok"}`}>
                    <span>완료 체크</span>
                    <strong>{finalStatus.summary.ok}/{finalStatus.summary.checks}</strong>
                    <small>{finalStatus.summary.done ? "운영 마감 완료" : "추가 확인 항목 있음"}</small>
                  </div>
                  <div className={`server-status-card ${finalStatus.summary.warnings ? "warning" : "ok"}`}>
                    <span>주의 항목</span>
                    <strong>{finalStatus.summary.warnings}</strong>
                    <small>외부 입력/계정 연결 기준</small>
                  </div>
                  <div className={`server-status-card ${finalStatus.summary.done ? "ok" : "warning"}`}>
                    <span>상태</span>
                    <strong>{finalStatus.summary.done ? "done" : "ready"}</strong>
                    <small>비밀값 미노출 점검</small>
                  </div>
                  <div className={`server-status-card ${finalStatus.readiness?.operational_ready ? "ok" : "warning"}`}>
                    <span>운영 준비</span>
                    <strong>{finalStatus.readiness?.operational_ready ? "ready" : "hold"}</strong>
                    <small>시스템/문서 기준</small>
                  </div>
                  <div className={`server-status-card ${finalStatus.readiness?.full_service_ready ? "ok" : "warning"}`}>
                    <span>전체 서비스</span>
                    <strong>{finalStatus.readiness?.full_service_ready ? "ready" : "blocked"}</strong>
                    <small>{finalStatus.readiness?.blocking_reason || "외부 입력 완료"}</small>
                  </div>
                  <div className="server-status-card warning">
                    <span>미완성 진행률</span>
                    <strong>{finalStatus.incomplete_progress?.avg_progress ?? 0}%</strong>
                    <small>{finalStatus.incomplete_progress?.complete ?? 0}/{finalStatus.incomplete_progress?.total ?? 0} 완료</small>
                  </div>
                  <div className={`server-status-card ${finalStatus.required_docs_completion?.ready ? "ok" : "warning"}`}>
                    <span>필수 문서</span>
                    <strong>{finalStatus.required_docs_completion?.percent ?? 0}%</strong>
                    <small>{finalStatus.required_docs_completion?.ready_count ?? 0}/{finalStatus.required_docs_completion?.total ?? 0} 준비</small>
                  </div>
                  <div className="server-status-card warning">
                    <span>외부 입력</span>
                    <strong>{finalStatus.external_input_summary?.total ?? 0}</strong>
                    <small>{finalStatus.external_input_summary?.ready ? "완료" : "운영 입력 대기"}</small>
                  </div>
                </div>
              )}
              {finalStatus?.error && <div className="admin-error compact">{finalStatus.error}</div>}
              {finalStatus?.readiness && (
                <div className="ops-warning-list">
                  <span>readiness: {finalStatus.readiness.state}</span>
                  <span>system {finalStatus.readiness.system_ready ? "ready" : "blocked"} · docs {finalStatus.readiness.required_docs_ready ? "ready" : "blocked"} · external {finalStatus.readiness.external_inputs_ready ? "ready" : "waiting"}</span>
                </div>
              )}
              <div className="ops-db-grid">
                {(finalStatus?.checks || []).map((item) => (
                  <article key={item.key} className={item.ok ? "" : "warning"}>
                    <strong>{item.label}</strong>
                    <span>{item.ok ? "완료" : "확인 필요"}</span>
                    <small>{item.key}</small>
                  </article>
                ))}
                <article>
                  <strong>업무 데이터</strong>
                  <span>메일계정 {finalStatus?.workflow?.mail_accounts ?? "-"} · 초안 {finalStatus?.workflow?.drafts ?? "-"}</span>
                  <small>서버 타깃 {finalStatus?.workflow?.ops_targets ?? "-"}개 저장</small>
                </article>
                <article>
                  <strong>AI/DB</strong>
                  <span>DB {finalStatus?.dependencies?.database?.tcp?.ok ? "정상" : "확인 필요"}</span>
                  <small>Ollama local {finalStatus?.dependencies?.ollama_local?.ok ? "정상" : "확인 필요"} · 107 {finalStatus?.dependencies?.ollama_107?.ok ? "정상" : "확인 필요"}</small>
                </article>
                {(finalStatus?.incomplete_progress?.top || []).map((item) => (
                  <article key={item.key} className={item.percent >= 100 ? "" : "warning"}>
                    <strong>#{item.priority} {item.label}</strong>
                    <span>{item.percent}%</span>
                    <small>{item.next_action}</small>
                  </article>
                ))}
                {Object.entries(finalStatus?.external_input_summary?.groups || {}).map(([group, data]) => (
                  <article key={group} className="warning">
                    <strong>{group} 입력</strong>
                    <span>{data.count}개 · {data.owner}</span>
                    <small>{(data.items || []).map((item) => item.label).join(", ")}</small>
                  </article>
                ))}
                {(finalStatus?.completion_gates || []).map((gate) => (
                  <article key={gate.key} className={gate.ready ? "" : "warning"}>
                    <strong>{gate.label}</strong>
                    <span>{gate.ready ? "ready" : "blocked"}</span>
                    <small>{gate.evidence}</small>
                  </article>
                ))}
              </div>
              {(finalStatus?.warnings || []).length > 0 && (
                <div className="ops-warning-list">
                  {(finalStatus.warnings || []).map((item) => <span key={item}>{item}</span>)}
                </div>
              )}
              <details className="ops-feature-checklist">
                <summary>문서/인수인계 파일</summary>
                <div>
                  {(finalStatus?.docs || []).map((item) => (
                    <code key={item.path}>{item.exists ? "있음" : "없음"} · {item.path}</code>
                  ))}
                </div>
              </details>
              {(finalStatus?.required_docs || []).length > 0 && (
                <details className="ops-feature-checklist">
                  <summary>필수 문서 체크리스트</summary>
                  <div>
                    {(finalStatus.required_docs || []).map((item) => (
                      <code key={item.path}>{item.exists ? "ready" : "missing"} · {item.name || item.path} · {item.size || 0} bytes</code>
                    ))}
                  </div>
                </details>
              )}
              {finalStatus?.external_input_summary && (
                <details className="ops-feature-checklist">
                  <summary>외부 입력 요약</summary>
                  <div>
                    <span>{finalStatus.external_input_summary.note}</span>
                    {Object.entries(finalStatus.external_input_summary.groups || {}).map(([group, data]) => (
                      <code key={group}>
                        {group} · {data.count}개 · {data.owner} · {(data.items || []).map((item) => `${item.label}(${item.verification_api})`).join(", ")}
                      </code>
                    ))}
                  </div>
                </details>
              )}
              {(finalStatus?.completion_gates || []).length > 0 && (
                <details className="ops-feature-checklist">
                  <summary>완료 게이트</summary>
                  <div>
                    {(finalStatus.completion_gates || []).map((gate) => (
                      <code key={gate.key}>
                        {gate.ready ? "ready" : "blocked"} · {gate.label} · {gate.evidence} · {gate.next_action}
                      </code>
                    ))}
                  </div>
                </details>
              )}
              <pre className="patch-preview validation-log">{finalStatus ? JSON.stringify(finalStatus, null, 2) : "최종 운영 상태를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "incomplete" && (
            <div className="ops-section-card">
              <div className="ops-section-head">
                <div>
                  <h3>미완성/보류 인벤토리</h3>
                  <span>운영 기능, 연동 필요 기능, 실험/보류/legacy 항목을 복구 대상과 혼동하지 않도록 분리합니다.</span>
                </div>
                <button className="admin-approve-button" onClick={loadIncompleteStatus}>인벤토리 새로고침</button>
              </div>
              {incompleteStatus?.summary && (
                <div className="server-status-grid">
                  <div className="server-status-card warning">
                    <span>조치 필요</span>
                    <strong>{incompleteStatus.summary.action}</strong>
                    <small>외부 입력/자격 연결</small>
                  </div>
                  <div className="server-status-card warning">
                    <span>실험/보류</span>
                    <strong>{(incompleteStatus.summary.experimental || 0) + (incompleteStatus.summary.deferred || 0)}</strong>
                    <small>제품/정책 검증 필요</small>
                  </div>
                  <div className="server-status-card ok">
                    <span>Legacy</span>
                    <strong>{incompleteStatus.summary.legacy}</strong>
                    <small>복구보다 혼선 방지</small>
                  </div>
                  <div className="server-status-card ok">
                    <span>완료 항목</span>
                    <strong>{incompleteStatus.summary.complete || 0}/{incompleteStatus.summary.total || 0}</strong>
                    <small>자동 산정 기준</small>
                  </div>
                  <div className="server-status-card warning">
                    <span>평균 진행률</span>
                    <strong>{incompleteStatus.summary.avg_progress || 0}%</strong>
                    <small>DB/환경값 기준</small>
                  </div>
                  <div className={`server-status-card ${incompleteStatus.summary.runbook_docs_ready === incompleteStatus.summary.blocked_inputs ? "ok" : "warning"}`}>
                    <span>Runbook</span>
                    <strong>{incompleteStatus.summary.runbook_docs_ready || 0}/{incompleteStatus.summary.blocked_inputs || 0}</strong>
                    <small>입력 패킷 문서 준비</small>
                  </div>
                </div>
              )}
              {incompleteStatus?.error && <div className="admin-error compact">{incompleteStatus.error}</div>}
              {incompleteStatus?.handoff_packet && (
                <div className="ops-chip-section">
                  <strong>인수인계 패킷</strong>
                  <div>
                    <code>
                      상태: {incompleteStatus.handoff_packet.ready ? "ready" : "needs docs"} · Runbook {incompleteStatus.handoff_packet.runbook_docs_ready || 0}/{incompleteStatus.handoff_packet.blocked_inputs || 0}
                    </code>
                    <code>
                      통합 문서: {incompleteStatus.handoff_packet.handoff_doc_exists ? `준비됨 (${incompleteStatus.handoff_packet.handoff_doc_size || 0} bytes)` : "없음"} · {incompleteStatus.handoff_packet.handoff_doc}
                    </code>
                    <code>
                      해시: doc {(incompleteStatus.handoff_packet.handoff_doc_sha256 || "").slice(0, 16) || "-"} · runbooks {(incompleteStatus.handoff_packet.runbook_manifest_sha256 || "").slice(0, 16) || "-"}
                    </code>
                    <code>
                      문서 세트: {incompleteStatus.handoff_packet.phase_docs_count || 0}개 · hash {(incompleteStatus.handoff_packet.phase_docs_sha256 || "").slice(0, 16) || "-"}
                    </code>
                    {incompleteStatus.handoff_packet.required_docs_completion && (
                      <code>
                        필수 문서: {incompleteStatus.handoff_packet.required_docs_completion.ready_count || 0}/{incompleteStatus.handoff_packet.required_docs_completion.total || 0} · {incompleteStatus.handoff_packet.required_docs_completion.percent || 0}% · {incompleteStatus.handoff_packet.required_docs_completion.ready ? "ready" : "missing"}
                      </code>
                    )}
                    {incompleteStatus.handoff_packet.phase_doc_categories && (
                      <code>
                        문서 분류: {Object.entries(incompleteStatus.handoff_packet.phase_doc_categories).map(([key, value]) => `${key} ${value}`).join(" · ")}
                      </code>
                    )}
                    {(incompleteStatus.handoff_packet.phase_docs_latest || []).length > 0 && (
                      <code>
                        최근 문서: {(incompleteStatus.handoff_packet.phase_docs_latest || []).map((doc) => `${doc.name} (${doc.modified_at_iso || doc.modified_at || "-"})`).join(" · ")}
                      </code>
                    )}
                    <code>보안 기준: {incompleteStatus.handoff_packet.secret_policy}</code>
                    {(incompleteStatus.handoff_packet.execution_items || []).map((item) => (
                      <code key={item.key}>
                        #{item.priority} {item.label} · {item.input_type} · 위치: {item.action_path} · 검증: {item.verification_api} · 문서: {item.runbook_exists ? "준비됨" : "없음"}
                      </code>
                    ))}
                    {(incompleteStatus.handoff_packet.phase_docs || []).length > 0 && (
                      <details className="ops-feature-checklist">
                        <summary>20260724 문서 세트</summary>
                        <div>
                          {Object.entries(incompleteStatus.handoff_packet.phase_doc_groups || {}).map(([category, docs]) => (
                            <details key={category} className="ops-feature-checklist">
                              <summary>{category} · {(docs || []).length}개</summary>
                              <div>
                                {(docs || []).map((doc) => (
                                  <code key={doc.path}>
                                    {doc.name} · {doc.size || 0} bytes · {doc.modified_at_iso || doc.modified_at || "-"} · {(doc.sha256 || "").slice(0, 16)}
                                  </code>
                                ))}
                              </div>
                            </details>
                          ))}
                        </div>
                      </details>
                    )}
                    {(incompleteStatus.handoff_packet.required_docs || []).length > 0 && (
                      <details className="ops-feature-checklist">
                        <summary>필수 문서 체크리스트</summary>
                        <div>
                          {(incompleteStatus.handoff_packet.required_docs || []).map((doc) => (
                            <code key={doc.name}>
                              {doc.exists ? "ready" : "missing"} · {doc.category || "doc"} · {doc.name} · {doc.size || 0} bytes · {(doc.sha256 || "").slice(0, 16)}
                            </code>
                          ))}
                        </div>
                      </details>
                    )}
                  </div>
                </div>
              )}
              {(incompleteStatus?.next_queue || []).length > 0 && (
                <div className="ops-chip-section">
                  <strong>다음 조치 우선순위</strong>
                  <div>
                    {(incompleteStatus.next_queue || []).slice(0, 6).map((item) => (
                      <code key={item.key}>
                        #{item.priority} {item.label} · {item.progress?.percent ?? 0}% · {item.next_action}
                        {item.action_path ? ` · 위치: ${item.action_path}` : ""}
                      </code>
                    ))}
                  </div>
                </div>
              )}
              {(incompleteStatus?.blocked_inputs || []).length > 0 && (
                <div className="ops-chip-section">
                  <strong>남은 입력 패킷</strong>
                  <div>
                    {externalInputVerifications && (
                      <code>
                        검증 등록부: {externalInputVerifications.verified_count || 0}/{externalInputVerifications.total || 0} 완료 · {(externalInputVerifications.pending_keys || []).join(", ") || "pending 없음"} · hash {(externalInputVerifications.ledger_sha256 || "").slice(0, 16) || "-"}
                      </code>
                    )}
                    {(externalInputVerifications?.history || []).length > 0 && (
                      <details className="ops-feature-checklist">
                        <summary>검증 등록부 최근 이력</summary>
                        <div>
                          {(externalInputVerifications.history || []).slice().reverse().slice(0, 10).map((entry, index) => (
                            <code key={`${entry.key}-${entry.at}-${index}`}>
                              {entry.at} · {entry.actor} · {entry.label || entry.key} · {entry.status} · {entry.evidence_note || "-"}
                            </code>
                          ))}
                        </div>
                      </details>
                    )}
                    {incompleteStatus.blocked_input_group_counts && (
                      <code>
                        그룹: {Object.entries(incompleteStatus.blocked_input_group_counts).map(([key, value]) => `${key} ${value}`).join(" · ")}
                      </code>
                    )}
                    {Object.entries(incompleteStatus.blocked_input_groups || {}).map(([group, items]) => (
                      (items || []).length > 0 && (
                        <details key={group} className="ops-feature-checklist">
                          <summary>{group} · {(items || []).length}개</summary>
                          <div>
                            {incompleteStatus.blocked_input_group_meta?.[group] && (
                              <>
                                <span>담당: {incompleteStatus.blocked_input_group_meta[group].owner}</span>
                                <span>초점: {incompleteStatus.blocked_input_group_meta[group].focus}</span>
                                <span>완료 기준: {incompleteStatus.blocked_input_group_meta[group].done_when}</span>
                              </>
                            )}
                            {(items || []).map((item) => (
                              <code key={item.key}>
                                #{item.priority} {item.label} · {item.input_type} · {item.required_fields?.join(", ")}
                              </code>
                            ))}
                          </div>
                        </details>
                      )
                    ))}
                    {(incompleteStatus.blocked_inputs || []).map((item) => (
                      <details key={item.key} className="ops-feature-checklist">
                        <summary>
                          #{item.priority} {item.label} · {item.input_type} · {item.progress?.percent ?? 0}%
                        </summary>
                        <div>
                          <span>대기 사유: {item.blocked_reason || "외부 입력 대기"}</span>
                          {item.verification_state && (
                            <span>
                              검증 상태: {item.verification_state.state} · {item.verification_state.ready ? "ready" : "waiting"} · {item.verification_state.percent ?? 0}%
                            </span>
                          )}
                          {(item.verification_state?.evidence || []).length > 0 && (
                            <span>검증 근거: {(item.verification_state.evidence || []).join(" · ")}</span>
                          )}
                          {item.verification_state?.next_verification && <span>다음 검증: {item.verification_state.next_verification}</span>}
                          <span>처리 위치: {item.action_path}</span>
                          <span>검증: {item.verification_api}</span>
                          <span>완료 기준: {item.done_when}</span>
                          {(item.required_hosts || []).length > 0 && <span>필요 서버: {item.required_hosts.join(", ")}</span>}
                          {(item.found_hosts || []).length > 0 && <span>확인 서버: {item.found_hosts.join(", ")}</span>}
                          <span>필요 입력: {(item.required_fields || []).join(", ")}</span>
                          {item.runbook_doc && <span>운영 문서: {item.runbook_doc}</span>}
                          {item.runbook_doc && <span>문서 상태: {item.runbook_exists ? `준비됨 (${item.runbook_size || 0} bytes)` : "없음"}</span>}
                          {(item.operator_steps || []).length > 0 && <span>처리 단계: {item.operator_steps.join(" > ")}</span>}
                          <span>보안 처리: {item.secret_handling}</span>
                          <span>다음 작업: {item.next_action}</span>
                          {item.verification_state?.operator_verification?.verified && (
                            <span>
                              운영 검증 기록: {item.verification_state.operator_verification.verified_at} · {item.verification_state.operator_verification.verified_by} · {item.verification_state.operator_verification.evidence_note}
                            </span>
                          )}
                          <span className="server-action-row">
                            <button
                              type="button"
                              className="admin-approve-button"
                              disabled={!!opsBusy}
                              onClick={() => updateExternalInputVerification(item, "verified")}
                            >
                              검증 완료 기록
                            </button>
                            <button
                              type="button"
                              className="admin-secondary-button"
                              disabled={!!opsBusy}
                              onClick={() => updateExternalInputVerification(item, "pending")}
                            >
                              대기 상태로 변경
                            </button>
                          </span>
                        </div>
                      </details>
                    ))}
                  </div>
                </div>
              )}
              <div className="ops-db-grid">
                {(incompleteStatus?.items || []).map((item) => (
                  <article key={item.key} className={item.level === "action" || item.level === "warn" ? "warning" : ""}>
                    <strong>{item.label}</strong>
                    <span>#{item.priority || "-"} · {item.status} · {item.category}</span>
                    <small>{item.owner} · 진행률 {item.progress?.percent ?? 0}% · {item.progress?.complete ? "완료" : "진행 중"}</small>
                    <em>{item.evidence}</em>
                    {(item.progress?.evidence || []).map((evidence) => <em key={evidence}>{evidence}</em>)}
                    <em className="ops-next-action">{item.next_action}</em>
                    {item.action_path && <em>처리 위치: {item.action_path}</em>}
                    {item.verification_api && <em>검증: {item.verification_api}</em>}
                    <em>
                      {item.codex_can_complete ? "Codex가 이어서 처리 가능" : "운영자/정책 입력 필요"}
                      {item.blocked_by_external_input ? " · 외부 입력 대기" : ""}
                    </em>
                    {item.blocked_reason && <em>대기 사유: {item.blocked_reason}</em>}
                    {item.done_when && <em>완료 기준: {item.done_when}</em>}
                    {(item.checklist || []).length > 0 && (
                      <details className="ops-feature-checklist">
                        <summary>체크리스트</summary>
                        <div>
                          {(item.checklist || []).map((check) => <span key={check}>{check}</span>)}
                        </div>
                      </details>
                    )}
                  </article>
                ))}
              </div>
              <details className="ops-feature-checklist">
                <summary>관리 원칙</summary>
                <div>
                  {(incompleteStatus?.policy || []).map((item) => <span key={item}>{item}</span>)}
                </div>
              </details>
              <pre className="patch-preview validation-log">{incompleteStatus ? JSON.stringify(incompleteStatus, null, 2) : "미완성 인벤토리를 불러오는 중입니다."}</pre>
            </div>
          )}

          {tab === "local" && (
            <>
              <div className="server-url-grid">
                <a href={serverStatus?.urls?.user || "https://ai.to-be.kr/"} target="_blank" rel="noreferrer">사용자 앱</a>
                <a href={serverStatus?.urls?.admin || "https://ai.to-be.kr/admin"} target="_blank" rel="noreferrer">관리자 앱</a>
                <a href={serverStatus?.urls?.health || "https://ai.to-be.kr/health"} target="_blank" rel="noreferrer">Health</a>
              </div>
              <div className="server-status-grid">
                <ServiceCard title="nginx" service={serverStatus?.services?.nginx} />
                <ServiceCard title="tobe-ai-backend" service={serverStatus?.services?.backend} />
                <div className={`server-status-card ${Number(disk.used_percent || 0) < 85 ? "ok" : "failed"}`}><span>디스크</span><strong>{disk.used_percent ?? "-"}%</strong><small>{disk.free_gb ?? "-"}GB free / {disk.total_gb ?? "-"}GB</small></div>
                <EnvironmentCard environment={serverStatus?.environment} />
              </div>
              <div className="server-action-row">
                {Object.keys(actionLabels).map((action) => (
                  <button key={action} className={["nginx_restart", "backend_restart"].includes(action) ? "admin-danger-button" : "admin-approve-button"} disabled={!!busyAction} onClick={() => runAction(action)}>
                    {busyAction === action ? "실행 중..." : actionLabels[action]}
                  </button>
                ))}
              </div>
              <div className="server-check-grid">
                <CheckBlock title="백엔드 health" result={checks.backend_health} />
                <CheckBlock title="nginx 설정" result={checks.nginx_config} />
                <CheckBlock title="인증서" result={checks.certbot} />
                <CheckBlock title="포트" result={checks.ports} />
                <CheckBlock title="Docker" result={checks.docker_ps} />
              </div>
              <div className="ops-db-grid">
                <article className={certificateInventory?.ok ? "" : "warning"}>
                  <strong>인증서 자동 갱신</strong>
                  <span>{certificateInventory?.ok ? "ready" : "check"}</span>
                  <small>
                    failed unit {certificateInventory?.failed_units_clean ? "0" : "확인 필요"} · warning {certificateInventory?.warning_count ?? 0}
                  </small>
                </article>
                {(certificateInventory?.items || []).map((cert) => (
                  <article key={cert.name} className={cert.warning || !cert.ok ? "warning" : ""}>
                    <strong>{cert.name}</strong>
                    <span>{cert.days_remaining == null ? "만료일 확인 필요" : `${cert.days_remaining}일 남음`}</span>
                    <small>
                      {cert.expires_at || "-"} · {cert.renewal?.authenticator || "renewal ?"}{cert.renewal?.installer ? `/${cert.renewal.installer}` : ""}
                    </small>
                  </article>
                ))}
              </div>
            </>
          )}

          {opsResult && (
            <div className={`deployment-result ${opsResult.ok === false ? "failed" : "ok"}`}>
              <strong>실행 결과</strong>
              <pre className="patch-preview validation-log">{opsResult.raw || opsResult.output || JSON.stringify(opsResult.metrics || opsResult, null, 2)}</pre>
            </div>
          )}

          {pendingAction && (
            <div className="server-action-confirm">
              <span>{actionLabels[pendingAction]} 작업을 실행하시겠습니까?</span>
              <button type="button" className="admin-danger-button" disabled={!!busyAction} onClick={() => executeAction(pendingAction)}>실행</button>
              <button type="button" className="admin-approve-button" disabled={!!busyAction} onClick={() => setPendingAction("")}>취소</button>
            </div>
          )}

          {result && (
            <div className={`deployment-result ${result.ok === false ? "failed" : "ok"}`}>
              <strong>작업 결과: {result.status}</strong>
              <pre className="patch-preview validation-log">{result.log || "출력 없음"}</pre>
            </div>
          )}
        </div>
      </div>

      {formOpen && (
        <div className="ops-credential-panel">
          <div className="ops-section-head">
            <div><h3>SSH 접속정보 저장</h3><span>저장 후 원격 헬스체크와 DB/서비스 점검이 가능합니다.</span></div>
            <button className="admin-approve-button" onClick={() => setFormOpen(false)}>닫기</button>
          </div>
          <div className="ops-form-grid">
            <input value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} placeholder="서버명" />
            <input value={form.host} onChange={(e) => setForm((p) => ({ ...p, host: e.target.value }))} placeholder="IP" />
            <input value={form.username} onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))} placeholder="사용자" />
            <input type="number" value={form.port} onChange={(e) => setForm((p) => ({ ...p, port: e.target.value }))} placeholder="포트" />
            <select value={form.auth_type} onChange={(e) => setForm((p) => ({ ...p, auth_type: e.target.value }))}>
              <option value="key">SSH 키</option>
              <option value="password">비밀번호</option>
            </select>
          </div>
          {form.auth_type === "key" ? (
            <textarea value={form.private_key} onChange={(e) => setForm((p) => ({ ...p, private_key: e.target.value }))} placeholder="-----BEGIN OPENSSH PRIVATE KEY-----..." rows={5} />
          ) : (
            <input type="password" value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} placeholder="SSH 비밀번호" />
          )}
          <div className="server-action-row">
            <button className="admin-approve-button" disabled={opsBusy === "save"} onClick={saveTarget}>{opsBusy === "save" ? "저장 중..." : "저장"}</button>
          </div>
        </div>
      )}
    </section>
  );
}

export default ServerManagementPanel;
